import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatHistoryUpdateUnitList,
	formatSystemUnitDetail,
	formatSystemUnitList,
} from './unit.helper';
import { SystemUnitActions } from './unit.redux';
import {
	ICreateUnitRequest,
	IPayloadDeleteUnitRequest,
	IPayloadGetUnitDetailRequest,
	IPayloadGetUnitListRequest,
	TPayloadGetHistoryUpdateUnitListRequest,
} from './unit.type';

export function* getSystemUnitList(
	action: PayloadAction<IPayloadGetUnitListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.TGetSystemUnitListResponse> =
			yield API.getSystemUnitList({
				searchTypes,
				...rest,
			});
		const unitList = formatSystemUnitList(res?.data?.content);

		yield put(
			SystemUnitActions.getSystemUnitListSuccess({
				...rest,
				unitList,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUnitActions.getSystemUnitListFailure());
	}
}

export function* createSystemUnit(action: PayloadAction<ICreateUnitRequest>) {
	const { values, callback } = action.payload;

	try {
		yield API.createSystemUnit(values);

		yield put(SystemUnitActions.createSystemUnitSuccess());
		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);
		yield put(SystemUnitActions.createSystemUnitFailure());
	}
}

export function* getSystemUnitDetail(
	action: PayloadAction<IPayloadGetUnitDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.TSystemUnitItem> =
			yield API.getSystemUnitDetail(id);
		const unitDetail = formatSystemUnitDetail(res?.data);
		yield put(
			SystemUnitActions.getSystemUnitDetailSuccess({
				unitDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUnitActions.getSystemUnitDetailFailure());
	}
}

export function* deleteSystemUnit(
	action: PayloadAction<IPayloadDeleteUnitRequest>
) {
	const { ids, callback } = action.payload;

	try {
		yield API.deleteSystemUnit(ids);

		yield put(SystemUnitActions.deleteSystemUnitSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(SystemUnitActions.deleteSystemUnitFailure());
	}
}

export function* getSystemHistoryUpdateSystemUnitList(
	action: PayloadAction<TPayloadGetHistoryUpdateUnitListRequest>
) {
	const { page, pageSize, field, unitId, callback } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetSystemHistoryUpdateUnitListResponse> =
			yield API.getHistoryUpdateSystemUnitList({
				page,
				pageSize,
				field,
				unitId,
			});
		const historyUpdateUnitList = formatHistoryUpdateUnitList(
			res?.data?.content
		);

		yield put(
			SystemUnitActions.getSystemHistoryUpdateSystemUnitListSuccess({
				page,
				pageSize,
				historyUpdateUnitList,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error as API.ApiResponseError);
		yield put(SystemUnitActions.getSystemHistoryUpdateSystemUnitListFailure());
	}
}
